import React from 'react'
import CustomersPage from "./CustomersPage"

function CustomersContainer() {
    return (
        <div className="CustomersContainer">
            <CustomersPage/>
        </div>
    )
}

export default CustomersContainer
